import { render, staticRenderFns } from "./CitySection.vue?vue&type=template&id=435c9a3f&lang=pug&"
import script from "./CitySection.vue?vue&type=script&lang=ts&"
export * from "./CitySection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports